import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import { Subvension } from 'app/model/subvension';
import { of } from 'rxjs/observable/of';

@Injectable()
export class SubvensionService {

  SUBVENSIONS: Array<Subvension> = [];

  constructor(public af: AngularFireDatabase) {
    this.reloadFromDb();
  }

  reloadFromDb(): void {
    this.af.list('/subwencje').snapshotChanges().subscribe(action => {
      this.SUBVENSIONS = [];
      action.forEach(a => {
        const val = a.payload.val();
        const subv = new Subvension();
        subv.id = a.payload.key;
        subv.nazwa = val.nazwa;
        subv.info = val.info;
        subv.warunki = val.warunki;
        subv.doplata_procent = val.doplata_procent;
        subv.kredyt_procent = val.kredyt_procent;
        subv.okres = val.okres;
        this.SUBVENSIONS.push(subv);
      });
    });
  }

  getSubvensions() {
    return this.SUBVENSIONS;
  }

  save(s: Subvension) {
    if (!s.id) {
      this.af.list('/subwencje/').push({
        info: s.info,
        nazwa: s.nazwa,
        warunki: s.warunki,
        doplata_procent: s.doplata_procent,
        kredyt_procent: s.kredyt_procent,
        okres: s.okres
      })
    } else {
      this.af.object('/subwencje/' + s.id).update({
        info: s.info,
        nazwa: s.nazwa,
        warunki: s.warunki,
        doplata_procent: s.doplata_procent,
        kredyt_procent: s.kredyt_procent,
        okres: s.okres
      });
    }
  }

  delete(id: string): void {
    this.af.object('/subwencje/' + id).remove()
      .then(a => {
        console.log('Deleted');
      });
  }

  getSubvension(id: string): Observable<Subvension> {
    return of(this.SUBVENSIONS.find(subv => subv.id === id));
  }

  getCurrentSubvension(): Subvension {
    return this.SUBVENSIONS.length > 0 ? this.SUBVENSIONS[0] : new Subvension();
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/services/subvension.service.ts